import styled from 'styled-components';

import { ToastContainer } from 'react-toastify';

// Theme
import { colors } from 'theme/theme';

export const AppLoggedContainer = styled.div`
  width: 100%;
  min-height: 100%;
  background-color: ${colors.softGrey};
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  height: 100% !important;
`;

export const StyledToastContainer = styled(ToastContainer).attrs({
  // custom props
})`
  .Toastify__toast-container {}
  .Toastify__toast {}
  .Toastify__toast--error {
    border: solid 1px ${colors.red};
    background-color: ${colors.softRed};
    color: ${colors.red};
  }
  .Toastify__toast--warning {
    border: solid 1px ${colors.yellow};
    background-color: ${colors.softYellow};
    color: ${colors.yellow};
  }
  .Toastify__toast--success {
    border: solid 1px ${colors.successGreen};
    background-color: ${colors.softGreen};
    color: ${colors.successGreen};
  }
  .Toastify__toast-body {}
  .Toastify__progress-bar {}
`;
